import axios from 'axios';
import { SearchAddressResponse } from '../Models/SearchAddressResponse';

export class DataGouvApi {
    public static searchAddress = (q: string, limit: number = 3) => {
        return axios.get<SearchAddressResponse>('https://api-adresse.data.gouv.fr/search/', {
            params: {
                q,
                limit
            }
        });
    }
}